// Definición modular de operaciones matemáticas.
// Para añadir nuevos temas en el futuro (negativos, fracciones, decimales, álgebra),
// basta con agregar una entrada aquí y habilitarla en MathEngine.allowedOps().

export function rnd(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function shuffle(arr) {
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export const OPERATIONS = {
  suma: {
    id: 'suma',
    symbol: '+',
    // Progresión de Planeta Suma controlada por el RESULTADO de la suma:
    //   Retos 1-2 (calentamiento): resultado 0-10
    //   Retos 3-4 (intermedio):    resultado 0-20
    //   Retos 5-6 (avanzado MVP):  resultado hasta 50
    // Solo enteros positivos; la dificultad sube de forma gradual, no aleatoria.
    gen(level) {
      const totals = {
        1: [2, 8],
        2: [4, 10],
        3: [8, 15],
        4: [12, 20],
        5: [20, 35],
        6: [30, 50],
      };
      const [lo, hi] = totals[Math.min(6, Math.max(1, level))];
      const total = rnd(lo, hi);
      const a = rnd(1, total - 1);
      const b = total - a;
      return { a, b };
    },
    apply: (a, b) => a + b,
    // Distractores cercanos y plausibles, escalados por magnitud (errores de posición/valor):
    // números pequeños -> ±1..±3; medianos -> ±10; grandes -> ±10/±20/±100.
    distractors: (a, b, ans) => {
      const d = [ans + 1, ans - 1, ans + 2, ans - 2];
      if (ans >= 20) d.push(ans + 10, ans - 10, ans + 3, ans - 3);
      if (ans >= 100) d.push(ans + 100, ans - 100, ans + 20, ans - 20);
      return d;
    },
  },

  resta: {
    id: 'resta',
    symbol: '−',
    gen(level) {
      const m = 8 + level * 4;
      return { a: rnd(4, m), b: rnd(2, m) };
    },
    apply: (a, b) => a - b,
    // Error común: sumar en lugar de restar (a+b); fallo de préstamo (±10).
    distractors: (a, b, ans) => [a + b, ans + 1, ans - 1, ans + 10, ans - 10, ans + 2],
  },

  mult: {
    id: 'mult',
    symbol: '×',
    gen(level) {
      const m = 3 + level;
      return { a: rnd(2, m), b: rnd(2, m) };
    },
    apply: (a, b) => a * b,
    // Errores comunes: sumar en vez de multiplicar, contar una fila de más/menos.
    distractors: (a, b, ans) => [a + b, ans + a, ans - a, ans + b, ans - b, ans + 1],
  },

  division: {
    id: 'division',
    symbol: '÷',
    // Genera divisiones exactas: a = b * cociente.
    gen(level) {
      const q = rnd(2, 4 + level);
      const b = rnd(2, 4 + Math.floor(level / 2));
      return { a: b * q, b, q };
    },
    apply: (a, b) => a / b,
    distractors: (a, b, ans) => [ans + 1, ans - 1, ans + 2, ans - 2, b],
  },
};
